var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_vm._v("\n    "+_vm._s(_vm.genereText)+"\n  ")]),_c('i',{staticClass:"icon-dotted"}),_c('span',[_vm._v(_vm._s(Math.floor(_vm.contentInfo.playtime /60))+"분")])])}
var staticRenderFns = []

export { render, staticRenderFns }